import styled from "styled-components";




export const FooterCrypto = styled.section `
  background-color: #111116;
  display: flex;
  flex-direction: column;
  padding: 20px;
  align-items: center;
  margin-top: 5%; 
`;

export const FooterInfo = styled.div`
  color: var(--white);
  text-align: center;
`;